import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AgreementPlannedMaintenancesComponent } from "../agreement-planned-maintenances/agreement-planned-maintenances.component";
import { PlannedMaintenanceDto } from "../../../../shared/models/maintenance/planned-maintenance.dto";
import { PlannedMaintenancesService } from "../../../../shared/services/planned-maintenances.service";
import { DialogService } from "@progress/kendo-angular-dialog";
import { PlannedMaintenanceDeviceDto } from "../../../../shared/models/maintenance/planned-maintenance-device.dto";
import { DevicesHierarchicalSelectorComponent } from "../../../../shared/components/devices-hierarchical-selector/devices-hierarchical-selector.component";
import { NewRequestDevice } from "../../../../shared/models/request/new-request/new-request-device";

@Component({
    selector: 'agreement-maintenance-devices',
    templateUrl: './agreement-maintenance-devices.component.html',
    styleUrls: [
        './agreement-maintenance-devices.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementMaintenanceDevicesComponent implements OnChanges {

    @Input() maintenance: PlannedMaintenanceDto;
    @Input() discount: number;
    @Input() isReadonly: boolean = false;

    @Output() deleteMaintenanceEvent: EventEmitter<PlannedMaintenanceDto> = new EventEmitter<PlannedMaintenanceDto>();
    @Output() updateMaintenanceEvent: EventEmitter<PlannedMaintenanceDto> = new EventEmitter<PlannedMaintenanceDto>();

    groupedDevices: PlannedMaintenanceDeviceDto[] = [];

    loading: boolean;

    constructor (
        private plannedMaintenancesService: PlannedMaintenancesService,
        private dialogService: DialogService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.groupDevices(this.maintenance.plannedMaintenanceDevices);
    }

    groupDevices(devices: PlannedMaintenanceDeviceDto[]) {
        this.groupedDevices = [];
        devices.forEach(device => {
            let groupedDevice = this.groupedDevices.find(x => x.deviceModelId == device.deviceModelId);
            if (groupedDevice == null) {
                device.count = 1;
                this.groupedDevices.push(device);
            }
            else {
                groupedDevice.count++;
            }
        });
    }

    getSumWithDiscount(device: PlannedMaintenanceDeviceDto) {
        let fullSum = device != null ? device.count * device.cost : 0;
        return fullSum - (fullSum / 100 * this.discount);
    }

    deleteMaintenance() {
        this.deleteMaintenanceEvent.emit(this.maintenance);
    }

    addNewDevice() {
        const dialogRef = this.dialogService.open({
            content: DevicesHierarchicalSelectorComponent,
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;

        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((devices: NewRequestDevice[]) => {
            dialogRef.close();
            this.loading = true;
            
            devices.forEach(device => {
                let newPlannedDevice = new PlannedMaintenanceDeviceDto;
                newPlannedDevice.agreementId = this.maintenance.agreementId;
                newPlannedDevice.cost = device.cost;
                newPlannedDevice.discount = device.discount;
                newPlannedDevice.deviceModelId = device.deviceModelId;
                newPlannedDevice.plannedMaintenanceId = this.maintenance.plannedMaintenanceId;

                for (let i = 0; i < device.quantity; i++) {
                    this.maintenance.plannedMaintenanceDevices.push(newPlannedDevice);
                }
            });

            this.updateMaintenanceEvent.emit(this.maintenance);
            this.loading = false;
        });
    }

    removeDeviceHandler({ dataItem }) {
        this.maintenance.plannedMaintenanceDevices = this.maintenance.plannedMaintenanceDevices.filter(x => 
            x.deviceModelId != dataItem.deviceModelId);
        this.updateMaintenanceEvent.emit(this.maintenance);
    } 

    get hasDevices(): boolean {
        return this.maintenance != null && this.maintenance.plannedMaintenanceDevices.length > 0;
    }
}